import script from "./VContentEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./VContentEditor.vue?vue&type=script&setup=true&lang=js"

import "./VContentEditor.vue?vue&type=style&index=0&id=77526dc2&scoped=true&lang=css"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77526dc2"]])

export default __exports__